import type { ExportRequestDataAccessRequest } from 'services/results/types'

import type { DataAccessRequestVerificationDetail } from './types'

export const mapDataAccessRequestVerificationQuerySource = (
  dataAccessRequest: DataAccessRequestVerificationDetail
): ExportRequestDataAccessRequest | undefined => {
  const { dataset, requesterContext } = dataAccessRequest

  if (!dataset) {
    return undefined
  }

  return {
    datasetName: dataset.datasetName,
    datasourceId: dataset.datasourceId,
    federatedConnectionId: dataset.federatedConnectionId,
    sourceOrganisationId: dataset.sourceOrganisationId,
    sourceOrganisationName: dataset.sourceOrganisationName,
    sourceWorkspaceId: dataset.sourceWorkspaceId,
    sourceWorkspaceName: dataset.sourceWorkspaceName,
    requesterOrganisationId: requesterContext.organisationId,
    requesterOrganisationName: requesterContext.organisationName,
    requesterWorkspaceId: requesterContext.workspaceId,
    requesterWorkspaceName: requesterContext.workspaceName,
    datasetColor: dataset.datasetColor,
    biobankId: dataAccessRequest.biobankId,
    omopSchemaName: dataAccessRequest.omopSchemaName,
    query: dataAccessRequest.query,
    cohort: dataAccessRequest.cohort,
    hasParticipantRestrictions: dataAccessRequest.hasParticipantRestrictions,
    participantFile: dataAccessRequest.participantFile
  }
}
